// Hocs
import asyncRoute from '../AsyncRoute'

// Exports
export function getComponent ({store}) {
  return new Promise((resolve) => {
    require.ensure([], (require) => {
      const View = require('hfty-components-auth').ForgotPassword

      resolve(View)

    /* Webpack named bundle   */
    }, 'forgotPassword')
  })
}

export default asyncRoute({getComponent, reducers: []})
